import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";
import { GSButton, GSFileSelect } from "golfstatus_react_components";
import { useImageSelector } from "../../hooks/formHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const SponsorLogoSelect = (props) => {
  const { sponsorID, context } = props;

  const [, , setLogo, removeLogo, getLogo, ,] = useImageSelector(
    context,
    "logo",
    25000000
  );

  const navigate = useGolfstatusNavigate();

  return (
    <GSFileSelect
      id="logo"
      description="Tap or drag a file to upload. The image ratio is 2:1. Accepted file types are .JPG, .PNG, .GIF under 25MB."
      setSelectedFiles={(files) => {
        setLogo(files);
      }}
      removeSourceItem={() => removeLogo("logo")}
      sourceList={getLogo()}
      accept=".jpg, .jpeg, .png"
      editImage={() => {
        navigate(`${sponsorID}/image?property=logo`);
      }}
      minWidth={600}
      minHeight={300}
      ratio={2}
      warningClicked={() => {
        navigate(`${sponsorID}/image?property=logo`);
      }}
      title={<GSButton buttonIcon={faArrowCircleUp} title="upload"></GSButton>}
      failedValidation={context.validationFailed}
    ></GSFileSelect>
  );
};

export default SponsorLogoSelect;
